import type { ISingleRow } from '../RowSection.helpers';

export const SingleRow = ({ label, component, noborder, adminNote, rowClass }: ISingleRow) => (
	<div
		className={`transactiondetails_itemrow${noborder ? ' noborder' : ''} border-bottom-dark-navy last-child${rowClass ? ' ' + rowClass : ''}`}
		data-testid='rowsection-single'
	>
		<div className='transactiondetails_item'>
			<label
				htmlFor='date'
				className='color-primary-50'
			>
				{label}
			</label>
			{component}
		</div>
		{adminNote}
	</div>
);
